import React from "react";

const Stat_Estimation = () => {
  return (
    <div>
      <h1>Stat Estimation</h1>
    </div>
  );
};

export default Stat_Estimation;
